import BaseSliderElement, { defineElement } from '@webtides/slider-element';

class SliderElement extends BaseSliderElement {
    connected() {
        super.connected();
        this.removeAttribute('cloak');

        this.requestUpdate().then(() => {
            this.setFadeOut();
        });
    }

    get isOverflowing() {
        return this.$refs.scroller.scrollWidth > this.$refs.scroller.offsetWidth;
    }

    setFadeOut() {
        let fadeLeft = false,
            fadeRight = false;

        if (this.isOverflowing) {
            fadeLeft = this.$refs.scroller.scrollLeft > 0;
            fadeRight =
                this.$refs.scroller.scrollLeft + this.$refs.scroller.offsetWidth < this.$refs.scroller.scrollWidth;
        }

        this.classList.toggle('fade-right', fadeRight);
        this.classList.toggle('fade-left', fadeLeft);
    }

    events() {
        return {
            ...super.events(),
            '[ref=scroller]': {
                scroll: () => {
                    this.setFadeOut();
                },
            },
        };
    }
}

export function define() {
    defineElement('slider-element', SliderElement);
}
